<template>
  <div class="krathong">
    <div class="respon">
      <!-- <div class="sun"></div> -->
      <!-- <div class="sky"> -->
      <!-- ส่งมาที่ละชื่อ  -->
      <div class="sun"></div>
      <div class="oblako o5">
        <div class="o_container5">
          <div class="ob1"></div>
          <div class="ob2"></div>
          <div class="ob3"></div>
          <div class="ob4"></div>
          <div class="ob5"></div>
        </div>
      </div>
      <div class="oblako o4">
        <div class="o_container4">
          <div class="ob1"></div>
          <div class="ob2"></div>
          <div class="ob3"></div>
          <div class="ob4"></div>
          <div class="ob5"></div>
        </div>
      </div>
      <div class="oblako o3">
        <div class="o_container3">
          <div class="ob1"></div>
          <div class="ob2"></div>
          <div class="ob3"></div>
          <div class="ob4"></div>
          <div class="ob5"></div>
        </div>
      </div>
      <div class="oblako o2">
        <div class="o_container2">
          <div class="ob1"></div>
          <div class="ob2"></div>
          <div class="ob3"></div>
          <div class="ob4"></div>
          <div class="ob5"></div>
        </div>
      </div>
      <div class="oblako o1">
        <div class="o_container1">
          <div class="ob1"></div>
          <div class="ob2"></div>
          <div class="ob3"></div>
          <div class="ob4"></div>
          <div class="ob5"></div>
        </div>
      </div>

      <div class="waves">
        <div class="wave"></div>
        <div class="wave"></div>
        <div class="wave"></div>
        <div class="wave"></div>
        <div class="items-container" id="itemsContainer" :style="{ animationDuration: duration + 's' }">
            <!-- <div class="item">
                <img src="https://via.placeholder.com/100" alt="Krathong Image">
                <div class="item-caption">Loy Krathong</div>
              </div> -->
        </div>
        <div class="image-slider"></div>
        <!-- <div class="image-slider">
            <div
              v-for="(image, index) in images"
              :key="index"
              :style="{ left: image.left + 'px', top: image.top + 'px'  }"
              class="slide"
            >
            <p>{{ image.caption }}</p>
              <img
                :src="image.url"
                alt="Slider Image"
              />
              
            </div>
          </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        token: "NDMyMTNDNUYtRkZFNy00NjI1LUIwNTQtMkQ0QTkzOTIyQTM3",
      items: [
        {
          image_url: require("../../../assets/loykrathong/krathong-item18.png"),
          caption: "Loy Krathong Celebration 1",id:1,
        },
      
        
        //   { image_url:require("../../../assets/loykrathong/krathong-item18.png"), caption: 'Loy Krathong Celebration 2' },
        //   { image_url: require("../../../assets/loykrathong/krathong-item16.png"), caption: 'Loy Krathong Celebration 3' },
        // Add more items if needed
      ],
      positionZindex: [20, 14, 9, 8],
      positionBottom: [20, 13, 14, 5, 21],
      duration: {
      type: Number,
      default: 10, // default animation duration
    },
    };
  },
  mounted() {
   
    this.fetchAndDisplayItem();
    const randomSpeed = Math.random() * 40 + 30; // Random duration between 8s and 13s
      const randomBottom = Math.floor(
        Math.random() * this.positionBottom.length
      );
      const bBottom = this.positionBottom[randomBottom];
      // Random vertical position between 10% and 80% of screen height
      const randomZindex = Math.floor(
        Math.random() * this.positionZindex.length
      );
      let Zindex = this.positionZindex[randomZindex];

      const classItem = document.getElementsByClassName("item");
      classItem.style.bottom=`${bBottom}vh`;
      classItem.style.zIndex=`${Zindex}`;
      classItem.style.animationDelay=`${2* 2}s`;
      classItem.style.animationDuration = `${randomSpeed}s`;

  },
  methods: {
    async fetchAndDisplayItem() {
      try {
        // Replace with the actual API URL that returns a single item
        // const response = await fetch('https://api.example.com/item');
        const item = this.items;

        // Create and animate the item from the API
        this.createMovingItem(item);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    createMovingItem(item) {
    

      const container = document.getElementById("itemsContainer");
      // console.log(item[0].image_url
      // );

      // Create a new div for the item
      const itemDiv = document.createElement("div");
    //   itemDiv.classList.add("item");


      // Create an img element
      const img = document.createElement("img");
      img.src = item[0].image_url; // Set image source from API data
      img.alt = item[0].caption || "Krathong Image";
      //   img.setAttribute("id","krathongImage");
      // Create a caption div
      const caption = document.createElement("div");
      caption.classList.add("item-caption");
      caption.textContent = item.caption || "Default Caption";

      // Append img and caption to item div
      itemDiv.appendChild(img);
      itemDiv.appendChild(caption);

      // Append the item div to the main container
      container.appendChild(itemDiv);
    
    },
    getKrathongStyle(index) {
      const randomSpeed = Math.random() * 40 + 30; // Random duration between 8s and 13s
      const randomBottom = Math.floor(
        Math.random() * this.positionBottom.length
      );
      const bBottom = this.positionBottom[randomBottom];
      // Random vertical position between 10% and 80% of screen height
      const randomZindex = Math.floor(
        Math.random() * this.positionZindex.length
      );
      let Zindex = this.positionZindex[randomZindex];
      return {
          bottom: `${bBottom}vh`,
          zIndex: `${Zindex}`,
          animationDelay: `${index * 2}s`, // Staggered start based on index
          animationDuration: `${randomSpeed}s`, // Random speed for each krathong
        };
      // let Zindex;
    
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  text-align: center;
  border-radius: 30px;
  padding: 5px 10px;

  background-color: pink;
  position: absolute;
  bottom: 1;
  left: 10px;
  box-sizing: border-box;
  color: #000000;
}
@keyframes sunshining {
  from {
    box-shadow: 0 0 20px 10px #f9ff54, 0 0 20px 10px #fff;
  }
  50% {
    box-shadow: 0 0 30px 15px #fbff81, 0 0 40px 20px #fff;
  }
  to {
    box-shadow: 0 0 20px 10px #f9ff54, 0 0 20px 10px #fff;
  }
}
.respon {
  /* background-size: cover;
    height: 100%;
    position: fixed;
    width: 100%;
    background-color: rgb(4, 1, 39);
    position: absolute; */
  /* z-index: -2; */
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url(../../../assets/loykrathong/loyy.png);
  background-size: cover;
  background-position: center;
  /* background-image: linear-gradient(#c6d8ff, #fff); */
  /* background-image: linear-gradient(
      to top,
      #a262b0,
      #884e9d,
      #6e3c8a,
      #552978,
      #3b1866
    ); */
  overflow: hidden;
  z-index: -2;
}

/* .container{
      position: absolute;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(#c6d8ff, #fff);
      overflow: hidden;
      z-index: -2;
  } */

.wave1,
.wave2,
.wave3 {
  position: absolute;
  width: 200%;
  height: 10px;
  bottom: 0;
  animation: move 16s linear alternate infinite;
  z-index: -1;
}
.wave1:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 80px;
  background-repeat: repeat;
  background-size: 80px 80px;
  background-image: radial-gradient(
    circle at 25px -5px,
    transparent 22px,
    #0f70d1 23px
  );
}
.wave1:after {
  content: "";
  position: absolute;
  left: -40px;
  right: 0;
  bottom: 0;
  height: 100px;
  background-repeat: repeat;
  background-size: 80px 100px;
  background-image: radial-gradient(
    circle at 25px 25px,
    #0f70d1 18px,
    transparent 19px
  );
}
.wave2 {
  bottom: 50px;
  left: -40px;
  z-index: -2;
  animation: move 8s alternate-reverse ease-in-out infinite;
}
.wave2:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 80px;
  background-repeat: repeat;
  background-size: 80px 80px;
  background-image: radial-gradient(
    circle at 25px -5px,
    transparent 22px,
    #0f65a1 23px
  );
}
.wave2:after {
  content: "";
  position: absolute;
  left: -40px;
  right: 0;
  bottom: 0;
  height: 100px;
  background-repeat: repeat;
  background-size: 80px 100px;
  background-image: radial-gradient(
    circle at 25px 25px,
    #0f65a1 18px,
    transparent 19px
  );
}
.wave3 {
  bottom: 100px;
  z-index: -3;
  animation: move 16s alternate-reverse linear infinite;
}
.wave3:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 80px;
  background-repeat: repeat;
  background-size: 80px 80px;
  background-image: radial-gradient(
    circle at 25px -5px,
    transparent 22px,
    #0f6081 23px
  );
}
.wave3:after {
  content: "";
  position: absolute;
  left: -40px;
  right: 0;
  bottom: 0;
  height: 100px;
  background-repeat: repeat;
  background-size: 80px 100px;
  background-image: radial-gradient(
    circle at 25px 25px,
    #0f6081 18px,
    transparent 19px
  );
}
@keyframes move {
  0% {
    transform: translateX(-200px);
  }
  100% {
    transform: translateX(-20px);
  }
}
.sun {
  position: absolute;
  top: 8%;
  left: 15%;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #ff5;
  box-shadow: 0 0 12px 6px #fe8;
  z-index: -4;
}

/*Sky*/
/* .sky {
    position: relative;
    height: 560px;
    background-image: linear-gradient(
      to top,
      #a262b0,
      #884e9d,
      #6e3c8a,
      #552978,
      #3b1866
    );
    z-index: 0;
  } */

.sun {
  position: absolute;
  top: 70px;
  left: 50%;
  margin-left: -30px;
  height: 60px;
  width: 60px;
  background: yellow;
  border-radius: 30px;
  box-shadow: 0 0 20px 10px #f9ff54;
  animation: sunshining 4s infinite linear;
}

/*END*/

/* clound */

.oblako {
  position: absolute;
}

.o1 {
  top: 50px;
  left: -100px;
}
.o2 {
  top: 100px;
  left: -100px;
}
.o3 {
  top: 150px;
  left: -100px;
}
.o4 {
  top: 200px;
  left: -100px;
}
.o5 {
  top: 250px;
  left: -100px;
}

.ob1 {
  width: 50px;
  height: 50px;
  box-shadow: 0 0 10px 8px #929292, 0 5px 10px #ccc;
  position: absolute;
  left: 20px;
  top: 10px;
  border-radius: 25px;
  background: #bbbbbb;
}

.ob2 {
  width: 40px;
  height: 40px;
  box-shadow: 0 0 10px 8px #929292, 0 5px 10px #ccc;
  position: absolute;
  left: 90px;
  top: 20px;
  border-radius: 20px;
  background: #bbbbbb;
}

.ob3 {
  width: 30px;
  height: 30px;
  box-shadow: 0 0 10px 8px #929292, 0 5px 10px #ccc;
  position: absolute;
  top: 30px;
  left: 120px;
  border-radius: 15px;
  background: #bbbbbb;
}

.ob4 {
  width: 20px;
  height: 20px;
  box-shadow: 0 0 10px 8px #929292, 0 5px 10px #ccc;
  position: absolute;
  top: 40px;
  border-radius: 10px;
  background: #bbbbbb;
}

.ob5 {
  width: 60px;
  height: 60px;
  box-shadow: 0 0 10px 8px #929292, 0 5px 10px #ccc;
  position: absolute;
  left: 50px;
  border-radius: 30px;
  background: #bbbbbb;
}

@keyframes skymove {
  from {
    transform: translateX(-200px);
  }
  to {
    transform: translateX(110vw);
  }
}

@keyframes skyscalefirst {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1);
  }
}
@keyframes skyscalesecond {
  from {
    transform: scale(0.8);
  }
  to {
    transform: scale(0.8);
  }
}
@keyframes skyscalethird {
  from {
    transform: scale(0.6);
  }
  to {
    transform: scale(0.6);
  }
}
@keyframes skyscalefourth {
  from {
    transform: scale(0.4);
  }
  to {
    transform: scale(0.4);
  }
}
@keyframes skyscalefifth {
  from {
    transform: scale(0.2);
  }
  to {
    transform: scale(0.2);
  }
}

.o1 {
  animation: skymove 40s infinite linear;
}
.o_container1 {
  animation: skyscalefirst 40s infinite linear;
}

.o2 {
  animation: skymove 60s infinite linear;
}
.o_container2 {
  animation: skyscalesecond 60s infinite linear;
}

.o3 {
  animation: skymove 80s infinite linear;
}
.o_container3 {
  animation: skyscalethird 80s infinite linear;
}

.o4 {
  animation: skymove 100s infinite linear;
}
.o_container4 {
  animation: skyscalefourth 100s infinite linear;
}

.o5 {
  animation: skymove 120s infinite linear;
}
.o_container5 {
  animation: skyscalefifth 120s infinite linear;
}

/* END */
/* tree*/
@-webkit-keyframes ani_tem {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: 1870px;
  }
}

@keyframes ani_tem {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: 1870px;
  }
}
.tree {
  width: 100%;
  height: 500px;
  position: absolute;
  /*background-image: url(../../../assets/loykrathong/58380.png);*/
  z-index: 6;
  opacity: 0.4;
  background-size: cover;
  background-repeat: repeat-x;
  bottom: -10px;
  /*-webkit-animation: ani_tem 25s linear 0s infinite normal none running ;
   animation:   ani_tem 25s linear 0s infinite normal none running;*/
}
/*END*/
/* temple*/
.temple {
  bottom: 400px;
  width: 100%;
  height: 600px;
  position: absolute;

  background-image: url(../../../assets/loykrathong/bg-loy-qr.png);
  z-index: 8;
  background-size: cover;
  background-repeat: repeat-x;
}

/* END*/

.temple {
  bottom: 400px;
  width: 100%;
  height: auto;
  /* position: absolute; */

  background-image: url(../../../assets/loykrathong/bg-loy-qr.png);
  z-index: 8;
  background-size: cover;
  /* background-repeat: repeat-x; */
  z-index: 99;
}

/* waves */

.wave {
  /* position: absolute;
    left: 0;
    bottom: 0;
    height: auto;
    width: 100%; */
  /* background-repeat: repeat-x, no-repeat; */
  position: absolute;
  left: 0;
  bottom: 0;
  height: auto;
  width: 100%;
}

/* .wave:nth-child(1) {
    z-index: 10;
    height: 140px;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(66,165,245)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
      linear-gradient(#42a5f5, #42a5f5);
    background-size: 140px 170px, 200% 100%;
    background-position: 0 0, 0 100px;
    animation: ani_wave1 2s linear alternate infinite;
  } */

.wave:nth-child(2) {
  z-index: 20;
  height: 140px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(60,100,159)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
    linear-gradient(#3c649f, #3c649f);
  background-size: 200px 140px, 200% 100%;
  background-position: 0 0, center 95px;
  background-repeat: repeat-x;
  -webkit-animation: 25s linear 0s infinite normal none running ani_wave;
  animation: 20s linear 0s infinite normal none running ani_wave;
}
.wave:nth-child(3) {
  z-index: 13;
  height: 180px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(44,69,107)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
    linear-gradient(#2c456b, #2c456b);
  background-size: 160px 50px, 200% 100%;
  background-position: 0 0, center 40px;
  background-repeat: repeat-x;
  -webkit-animation: 35s linear 0s infinite normal none running ani_wave;
  animation: 40s linear 0s infinite normal none running ani_wave;
}
.wave:nth-child(4) {
  z-index: 7;
  height: 260px;

  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(27,45,72)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
    linear-gradient(to right, #1b2d48, #1b2d48);

  background-size: 160px 60px, 200% 100%;
  background-position: 0 0, 0 40px;
  background-repeat: repeat-x;
  -webkit-animation: 25s linear 0s infinite normal none running ani_wave;
  animation: 25s linear 0s infinite normal none running ani_wave;
}
/* .wave:nth-child(5) {
        z-index: 4;
        height: 400px;
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(	21, 99, 177)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
         linear-gradient(to right, #1563b1, #1563b1);
        background-size: 90px 25px, 200% 100%;
        background-position: 0 0, 0 20px;
        animation: ani_wave5 2s linear alternate infinite;
      } */
@keyframes ani_wave1 {
  /* 0% {
        background-position-x: 0;
      }
      100% {
        background-position-x: -100px;
      } */
}

@-webkit-keyframes ani_wave {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: 1080px;
  }
}

@keyframes ani_wave {
  from {
    /* transform: translateX(-50px); */
    background-position-x: 0;
  }
  to {
    /* transform: translateX(50vw); */
    background-position-x: 1080px;
  }
}
/*krathog move*/
/* Container to hold the moving items */
.items-container {
  position: relative;
  width: 100vw;
  overflow: hidden;
  display: flex;
  gap: 20px;
}

/* Each item with image and caption */
.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  text-align: center;
  position: absolute;
  animation: skymove 40s infinite linear;
}

.item img {
  width: 100px;
  height: auto;
  border-radius: 8px;
}

.item-caption {
  margin-top: 8px;
  font-size: 1rem;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 5px;
  border-radius: 5px;
}

/* Keyframes for moving items left to right */
@keyframes moveLeftToRight {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100vw);
  }
}
</style>
